import React from "react";

export default function ValidationErrorMessage({
    inputName,
    message,
}: {
    inputName: string;
    message: string | null;
}) {
    if (!message) {
        return null;
    }

    return (
        <p
            className="mt-1 text-xs text-red-400 font-normal font-space leading-tight tracking-wide"
            id={`${inputName}-error`}
            dangerouslySetInnerHTML={{ __html: message }}
        />
    );
}
